let cancelableRequestCounter = 0;

type CancelableRequestInput = {
  cancelKey?: string;
  requestId?: string;
  hideLoader?: boolean;
  loaderMessage?: string;
  [key: string]: any;
};

type CancelableRequestMeta = {
  cancelKey: string;
  requestId: string;
  requestData: any;
  hideLoader: boolean;
  loaderMessage?: string;
};

export const getCancelableRequestMeta = (
  data: CancelableRequestInput | undefined,
  actionType: string,
  defaultHideLoader = true
): CancelableRequestMeta => {
  const cancelKey = data?.cancelKey || actionType;
  cancelableRequestCounter += 1;
  const requestId =
    data?.requestId || `${cancelKey}-${Date.now()}-${cancelableRequestCounter}`;
  const requestData = {
    ...(data || {}),
    cancelKey,
  };

  delete requestData.hideLoader;
  delete requestData.loaderMessage;
  delete requestData.requestId;

  return {
    cancelKey,
    requestId,
    requestData,
    hideLoader: data?.hideLoader ?? defaultHideLoader,
    loaderMessage: data?.loaderMessage,
  };
};
